import React from 'react';
import { Box, Button, Grid, Typography, backdropClasses, useMediaQuery } from '@mui/material';
import { sidebarWidth } from 'src/const';

import cover from 'src/App/assets/AirbticsProBackground.jpg';
import companyReview from 'src/App/assets/company_review.png';
import { useTheme } from '@material-ui/core';

import './airbticsPro.scss';
import BoxCard from './components/BoxCard';
import InfoGraphicsCard from './components/InfoGraphicCard';

const AirbticsProDashboard = ({
  sidebarOpen,
  matches,
}: {
  sidebarOpen: boolean;
  matches: boolean;
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile = useMediaQuery(theme.breakpoints.down(700));

  window.history.replaceState({}, '', '/airbtics-pro');

  return (
    <div className="airbticsPro--root">
      {/* Hero Section Starts */}

      {/* Hero Section Background Start */}
      <img
        src={cover}
        style={{
          width: '100%',
          height: isTablet ? 1800 : 1000,
          position: 'absolute',
          top: 0,
          left: sidebarOpen ? sidebarWidth : matches ? 0 : theme.spacing(8),
          objectFit: 'cover',
        }}
      />
      {/* Hero Section Background End */}

      {/* Hero Section Text left side */}
      <Grid
        container
        xs={12}
        style={{
          position: 'relative',
          paddingLeft: '10%',
          color: '#fff',
          width: '100%',
          marginTop: isTablet ? -100 : 'auto',
        }}
      >
        <Grid
          container
          item
          xs={isMobile ? 12 : 6}
          justifyContent={'flex-start'}
          alignItems={'space-around'}
          spacing={2}
        >
          <img
            src="https://mcusercontent.com/5b158330ab4807eaf11e312eb/images/ef92bc9c-1f3c-f31c-bfe3-f90f10f5de6a.png"
            alt="airbtics"
            style={{
              width: '140px',
              objectFit: 'cover',
            }}
          />
          <Grid item xs={12}>
            <Typography
              variant="h2"
              style={{ fontWeight: 700, color: '#fff', maxWidth: 300, fontFamily: 'Raleway' }}
            >
              Level up your ROI 55% more!
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body1" style={{ fontWeight: 500 }}>
              Access to the most comprehensive data and trend analysis for an entire country of your
              choice.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{
                color: '#fff',
                fontWeight: 'bold',
                background: '#FF5F01',
                padding: '20px 40px',
                borderRadius: '12px',
                fontSize: '20px',
                '&:hover': {
                  background: '#ff7e34',
                },
              }}
            >
              Show Me The Data
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body1">
              ⭐️⭐️⭐️⭐️⭐️ 5/5 rating <br /> Capterra, Google, & Trustpilot
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="body2"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <span style={{ fontWeight: 'bold', fontSize: 14 }}>
                "The most in-depth data analysis for vacation rentals."
              </span>{' '}
              - Sterling Jones, Founder @ Cohostin.com
            </Typography>
          </Grid>
        </Grid>

        {/* Hero Section Image right side */}
        <Grid
          container
          item
          xs={isMobile ? 12 : 6}
          justifyContent={'center'}
          alignItems={'center'}
          spacing={2}
        >
          <Box
            sx={{ background: '#fff4', width: 300, height: 400, marginTop: isMobile ? 4 : 'auto' }}
          ></Box>
        </Grid>
      </Grid>
      {/* Hero Section Ends */}

      {/* Review Section */}

      {/* Review Section Background */}
      <div
        style={{
          position: 'absolute',
          background: '#fff',
          left: 0,
          width: '100%',
          height: 300,
          zIndex: 0,
          transform: 'translateY(40px)',
        }}
      />

      {/* Review section main */}
      <Grid
        container
        xs={12}
        justifyContent={'center'}
        alignItems={'center'}
        style={{
          position: 'relative',
          width: '100%',
          background: '#fff',
          marginTop: '40px',
          color: '#2A2A2A',
        }}
      >
        <Grid item xs={8}>
          <img
            src={companyReview}
            style={{
              // minWidth: '300px',
              width: '100%',
              // height: '100px',
              objectFit: 'cover',
            }}
          />
        </Grid>
      </Grid>

      {/* Review Section Ends */}

      {/* Features Section */}

      {/* Feature section background */}
      <div
        style={{
          position: 'absolute',
          background: '#cde4e9',
          left: 0,
          width: '100%',
          height: isTablet ? 2700 : 1600,
          zIndex: 0,
          transform: 'translateY(0px)',
        }}
      />

      {/* Cards Displaying with vs without airbtics */}
      <Grid
        container
        spacing={2}
        style={{ position: 'relative', zIndex: 1, marginTop: '20px', paddingTop: '40px' }}
        justifyContent={'center'}
      >
        <Grid item sx={{ maxWidth: '800px' }}>
          <Typography variant="h3" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
            Without the right set of data, property investors are losing ROI
          </Typography>
        </Grid>

        <Grid item sx={{ marginTop: '20px', marginBottom: '20px', maxWidth: '1000px' }}>
          <Typography
            variant="body1"
            sx={{ textAlign: 'center', color: '#686868', fontSize: '20px' }}
          >
            With Airbtics Pro, you will get the most in-depth data and trend analysis report of a
            city and a country of your choice. Plus, a powerful set of analytic tools to help you
            make data-driven decisions.
          </Typography>
        </Grid>

        <Grid item container justifyContent={'center'} alignItems={'center'} spacing={4}>
          <Grid item>
            <BoxCard title={'👎🏼 Without Airbtics'} details={'2-Bedroom Apartment in Dallas'} />
          </Grid>
          <Grid item>
            <BoxCard
              title={'👍🏼 With Airbtics!'}
              details={
                '* 5-year data report trend analysis of population growth, job growth, home price growth, crime rate trend, and income growth per sub-market in your chosen city.'
              }
            />
          </Grid>
        </Grid>

        {/* Airbtics Pro Image */}
        <Grid item container xs={12}>
          <Grid item xs={6}>
            <img
              src="https://mcusercontent.com/5b158330ab4807eaf11e312eb/images/6eff746e-29b5-54a7-9b4a-b240b9326008.png"
              style={{ width: '65%', objectFit: 'cover', marginTop: '30px' }}
            />
          </Grid>
        </Grid>

        {/* Feature Description with Image card */}
        <Grid
          item
          container
          xs={12}
          justifyContent={'center'}
          spacing={8}
          sx={{ marginBottom: '100px' }}
        >
          <Grid item xs={12} justifyContent={'center'}>
            <InfoGraphicsCard
              title={'Full Access to Airbtics Plan'}
              content={
                'Need help with a finicky houseplant or tips on the best fertilizer to grow your garden? Our guides have got you covered. Sign up to get weekly updates delivered directly to your inbox.'
              }
              image={'https://eep.io/mc-cdn-images/template_images/gallery/lp-ecomm-img-3-2.0.png'}
              theme={theme}
            />
          </Grid>
          <Grid item xs={12} justifyContent={'center'}>
            <InfoGraphicsCard
              title={'Full Access to Airbtics Plan'}
              content={
                'Need help with a finicky houseplant or tips on the best fertilizer to grow your garden? Our guides have got you covered. Sign up to get weekly updates delivered directly to your inbox.'
              }
              image={'https://eep.io/mc-cdn-images/template_images/gallery/lp-ecomm-img-3-2.0.png'}
              reverse={true}
              theme={theme}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* Features Section Ends */}

      {/* Footer Starts */}
      {/* Footer Background Image */}
      <div
        style={{
          width: '100%',
          height: 600,
          position: 'absolute',
          left: sidebarOpen ? sidebarWidth : matches ? 0 : theme.spacing(8),
          objectFit: 'cover',
          backgroundImage:
            'linear-gradient(rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0.32)), url("https://eep.io/mc-cdn-images/template_images/gallery/lp-ecomm-bg-2-2.0.png")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center top',
          backgroundSize: 'cover',
        }}
      />

      <Grid
        container
        direction={'column'}
        alignItems={'flex-start'}
        sx={{ position: 'relative', zIndex: '+1', padding: '140px 60px' }}
      >
        <Typography variant="h3" style={{ fontWeight: 700, color: '#fff' }}>
          LET'S GROW
          <br />
          TOGETHER
        </Typography>
        <Button
          variant="contained"
          sx={{
            color: '#000',
            fontWeight: 'bold',
            background: '#fff',
            padding: '10px 20px',
            borderRadius: '4px',
            fontSize: '16px',
            marginTop: '20px',
            '&:hover': {
              background: '#888',
            },
          }}
        >
          Subscribe
        </Button>
      </Grid>
      {/* Footer Ends */}
    </div>
  );
};

export default AirbticsProDashboard;
